// Shared clipboard helper with a graceful fallback for headless / sandboxed
// browsers where navigator.clipboard.writeText() is unavailable or blocked.
// Returns true if the copy succeeded.
//
// Extracted out of HistoricalCompare.jsx where the same fallback was
// duplicated between handleCopyShareLink and ShareQrModal.copyAgain (DRY
// flag from iter_28 testing-agent code review).
export async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    // Older browsers / iframes / Chrome over http: fall back to the
    // textarea + execCommand('copy') dance.
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (_inner) {
      return false;
    }
  }
}
